import { render } from "./LoadingHome.vue?vue&type=template&id=275061fb"
import script from "./LoadingHome.vue?vue&type=script&lang=js"
export * from "./LoadingHome.vue?vue&type=script&lang=js"

import "./LoadingHome.vue?vue&type=style&index=0&id=275061fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__